import {
    getAxios,
    formDataToRequestParams
} from './axios'

import {
    responseResolveInterceptor
} from './interceptors';

import {addAuthTokenData} from './member';

export function getProfile({id = undefined, nick = undefined}) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);
    
    return axios.request({
        url: '/profile/',
        method: 'get',
        params: addAuthTokenData({id, nick})
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/profile.js